import { Container, Typography, Box } from "@mui/material";

const Discord = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, height: "calc(100vh - 120px)" }}>
      <Typography variant="h4" gutterBottom>
        Discord Chat
      </Typography>
      <Box
        sx={{
          height: "calc(100vh - 200px)",
          width: "100%",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <iframe
          title="Discord Chat"
          src="https://e.widgetbot.io/channels/963454567490654281/1344615339337580625"
          width="100%"
          height="100%"
          frameBorder="0"
          allow="clipboard-write; encrypted-media"
        />
      </Box>
    </Container>
  );
};

export default Discord;
